import React, { useEffect, useState } from "react";
import { ArrowDown, ArrowLeft, ArrowRight, X } from "react-feather";
import Dots from "../../images/Dots";
import Masonry, { MasonryBox } from "../../Layout/Masonry/Masonry";
import Typing from "../../Layout/Typing/Typing";
import images, { slideshow } from "../../utils/gallery";
import { meshNetwork } from "../../utils/images";
import "./gallery.scss";

const Gallery = () => {
	const [slideImage, setSlideImage] = useState(slideshow[0]);
	const [frame, setFrame] = useState(-1);
	const closeFrame = () => {
		setFrame(-1);
		document.body.style.overflow = "auto";
	};
	useEffect(() => {
		const interval = setInterval(() => {
			setSlideImage(
				slideshow[Math.floor(Math.random() * slideshow.length)]
			);
		}, 2500);
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") closeFrame();
		});
		return () => clearInterval(interval);
	}, []);
	return (
		<main className="gallery">
			<section className="gallery-hero">
				<div className="gallery-hero-left">
					<h1 className="gallery-hero-h1">
						<Typing>Our Story</Typing>
					</h1>
					<p>
						"Lorem ipsum dolor sit amet, consectetur adipiscing
						elit, sed do eiusmod tempor incididunt ut labore et
						dolore magna aliqua. Ut enim ad minim veniam
					</p>
					<div
						className="gallery-hero-left-scroll-down"
						onClick={() => window.scrollTo(0, window.innerHeight)}
					>
						<ArrowDown />
						<span>Scroll Down</span>
					</div>
					<h2 className="gallery-hero-left-label">Gallery</h2>
				</div>
				<div className="gallery-hero-mid"></div>
				<div className="gallery-hero-right">
					<div
						className="gallery-hero-slideshow"
						style={{ backgroundImage: `url(${slideImage})` }}
					>
						<span></span>
						<span></span>
						<span></span>
						<Dots
							fill="var(--white)"
							className="gallery-hero-right-dots"
						/>
						<span></span>
					</div>
				</div>
			</section>
			<section
				className="gallery-body"
				style={{
					backgroundImage: `url(${meshNetwork})`,
				}}
			>
				<Masonry lg={4} md={3} sm={2}>
					{images.map((image, index) => (
						<MasonryBox key={index}>
							<div
								className="gallery-body-img"
								onClick={() => {
									setFrame(index);
									document.body.style.overflow = "hidden";
								}}
							>
								<img src={image} alt={image} />
							</div>
						</MasonryBox>
					))}
				</Masonry>
			</section>
			{frame >= 0 && (
				<section className="gallery-frame">
					<div
						className="gallery-frame-overlay"
						onClick={closeFrame}
					></div>
					<div className="gallery-frame-img" data-aos="zoom-in">
						<img src={images[frame]} alt={images[frame]} />
					</div>
					{frame > 0 && (
						<button
							className="gallery-frame-prev"
							onClick={() => setFrame(frame - 1)}
						>
							<ArrowLeft />
						</button>
					)}
					{frame < images.length - 1 && (
						<button
							className="gallery-frame-next"
							onClick={() => setFrame(frame + 1)}
						>
							<ArrowRight />
						</button>
					)}
					<button
						className="gallery-frame-close"
						onClick={() => setFrame(-1)}
					>
						<X />
					</button>
				</section>
			)}
		</main>
	);
};

export default Gallery;
